import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { GetCCDAMessageComponent } from 'src/app/CCDA/get-ccdamessage/get-ccdamessage.component';
import { CCDAService } from '../ccda.service';
import { PatientformService } from 'src/app/Services/PatientForms/patientform.service';
import { DirectMessagesComponent } from 'src/app/message/direct-messages/direct-messages.component';
import { forkJoin, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component_RoleMasterEnum, UserRoleservice } from 'src/app/Services/common.service';

import { MatAccordion } from '@angular/material/expansion';
import { configuration } from 'src/environments/environment';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-clinical-summary',
  templateUrl: './clinical-summary.component.html',
  styleUrls: ['./clinical-summary.component.css']
})
export class ClinicalSummaryComponent implements OnInit {
  @ViewChild(MatAccordion, { static: false }) accordion: MatAccordion;
  step = 0;

  PatientId = '';
  PatientVisitDetails: any = [];
  PatientPersonalInfo: any;
  PatientRecordRequest: any = []
  PatientVisitDetails$: Observable<any>
  PatientRecordRequest$: Observable<any>
  UserPermissions = {
    GenerateCCDA: '',
    ImportCCDA: ''
  };
  constructor(public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _CCDAService: CCDAService,
    private _PatientformService: PatientformService,
    private _toaster: ToastrService,
    private router: Router,
    private _userRoleservice: UserRoleservice,
    private spinner: NgxSpinnerService,
  ) {


    this.UserPermissions.GenerateCCDA = this._userRoleservice.getPermissionsByComponentId(Component_RoleMasterEnum.GenerateCCDA);
    this.UserPermissions.ImportCCDA = this._userRoleservice.getPermissionsByComponentId(Component_RoleMasterEnum.ImportCCDA);
    // if (data) {
    //   this.PatientId = data.patId
    // }



  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  ngOnInit() {
    this.PatientId = sessionStorage.getItem("patientId");
    if (this.PatientId == null) {
      this._toaster.warning("Please Select PatientID");

    }

    if (this.PatientId != null) {
      this.spinner.show();
      this.PatientRecordRequest$ = null;
      forkJoin(
        this._CCDAService.PatientActiveData_Reconsolation(this.PatientId),
        this._CCDAService.GetPatientRecordRequest(this.PatientId)
      ).subscribe(([reconsilation, recordReq]: any) => {
        // if (reconsilation.allergies.length > 0) {
        //   reconsilation.allergies.forEach(element => {
        //     element.Reaction = element.Reaction.replace(",", "");
        //   });
        // }
        this.PatientVisitDetails = reconsilation;
        this.PatientRecordRequest = recordReq;
        this.spinner.hide();
      }, (err) => { this.spinner.hide(); })
      /*
      this.PatientVisitDetails$ = this._CCDAService.PatientActiveData_Reconsolation(this.PatientId);
      // this._CCDAService.PatientActiveData_Reconsolation(this.PatientId)
      this.PatientVisitDetails$.subscribe(res => {
        this.PatientVisitDetails = res;
      })
      this.fnGetRecordRequest();
      */
    }
  }
  fnGetRecordRequest() {
    this.spinner.show();
    //  this.PatientRecordRequest$ = this._CCDAService.GetPatientRecordRequest(this.PatientId);
    this._CCDAService.GetPatientRecordRequest(this.PatientId)
      //this.PatientRecordRequest$
      .subscribe(result => {
        this.PatientRecordRequest = result;
        this.spinner.hide();
      }, (err) => { this.spinner.hide(); })
  }

  fnGenerateCDA(element) {
    const dialogRef = this.dialog.open(GetCCDAMessageComponent, {
      width: '950px',
      height: '900px',
      data: { patientid: this.PatientId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.fnGetRecordRequest();
    });
  }
  onValueChanged(type: string, element: any) {

    if (type == "P") {
      this.fnShowPreview(element.HTMLInformation);
    }
    else if (type == 'DL') {
      this.fnDownloadFile(element);
    }
    else if (type == 'T') {
      this.fnTransmitFile(element);
    }
    else if (type == 'D') {
      this.fnDeleteFile(element);
    }
  }
  fnDeleteFile(element) {
    this._CCDAService.DeletePatientRecordRequest(element.ID).subscribe(res => {
      this._toaster.success("Successfully Deleted");
      this.fnGetRecordRequest();
    })
  }
  fnTransmitFile(element) {
    const dialogRef = this.dialog.open(DirectMessagesComponent, {
      width: '950px',
      height: '900px',
      data: {
        patientid: element.PatientId,
        encounterid: element.encounters,
        isorder: true,
        xmlInfo: element.CCDAMessage,
        appointmentDate: element.CreatedOn,
        HtmlPath: element.HtmlPath
      }
    });
    dialogRef.afterOpened().subscribe(res => {
      if (dialogRef.componentInstance.directaddress == '' || dialogRef.componentInstance.directaddress == undefined || dialogRef.componentInstance.directaddress == 'undefined'
        || dialogRef.componentInstance.directaddress == "null"
      ) {
        // this.toastr.error("No direct address for this provider;")
        dialogRef.close();
      }
      else {
        dialogRef.componentInstance.hidetab = true;
        dialogRef.componentInstance.funCompose();
        dialogRef.componentInstance.mapValuestoObjectforClinicalSummary();
      }
    })

  }

  fnShowPreview(CCDA_HTML: string) {
    // The HTML is stored in blob storage, not under the API's Downloads folder; the record
    // list API already returns it in HTMLInformation, so render that instead of a file URL.
    if (!CCDA_HTML) {
      this._toaster.error("CDA preview is not available for this document.");
      return;
    }
    const previewUrl = URL.createObjectURL(new Blob([CCDA_HTML], { type: "text/html" }));
    window.open(previewUrl, "MsgWindow", "width=500,height=800");
    setTimeout(() => URL.revokeObjectURL(previewUrl), 60000);
  }

  fnDownloadFile(element) {
    const winUrl = URL.createObjectURL(
      new Blob([element.CCDAMessage], { type: "text/html" })
    );
    let filename = 'CCDA.xml';
    if (this.PatientRecordRequest && this.PatientRecordRequest.length > 0) {
      filename = this.PatientRecordRequest[0].PatientId;
    }
    filename = filename + '_' + element.DocumentType;
    let blob: any = new Blob([element.CCDAMessage], { type: 'application/xml; charset=utf-8' });
    var FileSaver = require('file-saver');
    FileSaver.saveAs(blob, filename);

    /// HTML Data
    const winUrl1 = URL.createObjectURL(
      new Blob([element.HTMLInformation], { type: "text/html" })
    );
    let filename1 = 'CCDA.html';
    if (this.PatientRecordRequest && this.PatientRecordRequest.length > 0) {
      filename1 = this.PatientRecordRequest[0].PatientId;
    }
    filename1 = filename1 + '_' + element.DocumentType;
    if (filename1.indexOf('.html') == -1)
      filename1 = filename1 + '.html';
    let blob1: any = new Blob([element.HTMLInformation], { type: 'application/html; charset=utf-8' });
    saveAs(blob1, filename1);
  }

  fnvalidateandUpdate(files: FileList) {
    this.spinner.show();
    const filepath = "http://25.58.178.202:8080/referenceccdaservice/?validationObjective=ccda_ig_only&&referenceFileName=170.315_b1_toc_amb_sample1_v13.pdf&&curesUpdate=true&&vocabularyConfig=ccdaReferenceValidatorConfig";
    this._CCDAService.uploadCDAFile(filepath, files.item(0)).subscribe((res: any) => {
      const parsedJs = JSON.parse(res);
      const ValidationMessageJson = {
        ccdaDocumentType: parsedJs.resultsMetaData.ccdaDocumentType,
        ccdaFileName: parsedJs.resultsMetaData.ccdaFileName,
        ccdaVersion: parsedJs.resultsMetaData.ccdaVersion,
        objectiveProvided: parsedJs.resultsMetaData.objectiveProvided,
        ResultsMetadata: parsedJs.resultsMetaData.resultMetaData,
        serviceError: parsedJs.resultsMetaData.serviceError,
        ccdaValidationResults: parsedJs.ccdaValidationResults,
        vocabularyValidationConfigurationsCount: parsedJs.resultsMetaData.vocabularyValidationConfigurationsCount,
        vocabularyValidationConfigurationsErrorCount: parsedJs.resultsMetaData.vocabularyValidationConfigurationsErrorCount,
        severityLevel: parsedJs.resultsMetaData.severityLevel,
        totalConformanceErrorChecks: parsedJs.resultsMetaData.totalConformanceErrorChecks

      }
      sessionStorage.setItem('ValidationMessageJson', JSON.stringify(ValidationMessageJson));
      this.handleFileInput(files);
      this.spinner.hide();
    },

      (err) => { console.log(err); this.spinner.hide(); });
  }
  handleFileInput(files: FileList) {

    var fr = new FileReader();
    var self = this;
    fr.onload = function () {
      /// let XMLFileString = fr.result;
      sessionStorage.setItem("XMLFileString", fr.result.toString());
      self.router.navigateByUrl("/ImportCDAXML");
      //   self.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      //     self.router.navigate(["ImportCDAXML"]));
      //   // this.router.navigate(["Appointments"]);
      // });
    }
    // var fileToUpload: File | null = null;
    fr.readAsText(files.item(0));




  }
  fnDateFormat(datestr) {
    if (datestr && datestr.length >= 8 && datestr.indexOf('-') != -1) {
      return (datestr.split('-')[1] + '/' + datestr.split('-')[0] + '/' + datestr.split('-')[2]).slice(0, 10)
    }
    return datestr;

  }
}
